module.exports = __webpack_public_path__ + "img/albania.b8a068c3.svg";